import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { default as useMeasure } from 'react-use-measure';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import { Mode } from './enums';
import { modePresets } from './model';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, Props>(function Component(
  { mode = Mode.BOTTOM, children, shouldStretched, withGhost = true, ...props },
  forwardedRef
) {
  const [ref, { height }] = useMeasure();

  return (
    <>
      <RootComponent
        {...props}
        Component="div"
        baseClassName={clsx(
          css.root,
          modePresets[mode],
          shouldStretched && css.stretched
        )}
        ref={forwardedRef}
      >
        <div ref={ref}>{children}</div>
      </RootComponent>

      {withGhost && <div style={{ height }} />}
    </>
  );
});
